export default __webpack_public_path__ + "static/media/15.c1f8bc2c.svg";